export default __webpack_public_path__ + "static/media/top_divider.984dfe68.svg";